// extracted by mini-css-extract-plugin
module.exports = {"term":"KeyTerm_term__1Mslb","description":"KeyTerm_description__1ZdD2","container":"KeyTerm_container__3APNC"};